// extracted by mini-css-extract-plugin
export default {"container":"detail_container__j-JTY","table":"detail_table__rSV+O","datepicker-full":"detail_datepicker-full__xzDG1"};